<!--eslint-disable-->
<template>
  <step-wrapper space-between>
    <step-header :text="text" step="4" step-count="4" strong/>
    <content-wrapper type="big">
      <form-component v-model="formModel" :fields="form"/>
      <collapse>
        <span slot="clickable">
          Zgodnie z art. 13 ust. 1 i 2 Rozporządzenia Parlamentu Europejskiego i
          Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób
          fizycznych w związku z przetwarzaniem danych osobowych i w sprawie
          swobodnego przepływu takich danych oraz uchylenia dyrektywy
          95/46/WE (ogólne rozporządzenie o ochronie danych, dalej „RODO”) WIĘCEJ >>
        </span>
        <div slot="hidden">
          <p>Zgodnie z art. 13 ust. 1 i 2 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27
            kwietnia 2016 r. w sprawie ochrony osób fizycznych
            w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia
            dyrektywy 95/46/WE (ogólne
            rozporządzenie o ochronie danych, dalej „RODO”) informujemy, iż:</p>

          <p>1. Administratorem danych osobowych uczestników Konkursu To Miasto, którzy wyrazili dobrowolne zgody na
            przetwarzanie
            danych osobowych w celach marketingowych jest Grupa Żywiec S.A. z siedzibą w Żywcu, ul. Browarna 88, 34-300
            Żywiec.</p>

          <p>2. Przestrzeganie zasad ochrony danych w Grupie Żywiec S.A. nadzoruje wyznaczony Oficer Bezpieczeństwa
            Ochrony Danych, z którym można
            skontaktować się poprzez wiadomość wysłaną na adres dane.osobowe@grupazywiec.pl.</p>

          <p>3. Dane osobowe podane przez uczestników Konkursu To Miasto, będą przetwarzane przez Grupę Żywiec S.A. w
            celach
            marketingowych, a podstawą prawną przetwarzania danych jest zgoda uczestników Konkursu To Miasto, (art. 6
            ust. 1 lit. a RODO).</p>

          <p>4. Odbiorcami Pani/Pana danych osobowych będzie Żywiec Sprzedaż i Dystrybucja Sp. z o.o. oraz inne podmioty
            przetwarzające, w tym
            agencje marketingowe, przy czym takie podmioty będą przetwarzać dane na podstawie umowy z administratorem i
            wyłącznie zgodnie z poleceniami
            administratora.</p>

          <p>5. Pani/Pana dane osobowe będą przechowywane do momentu wycofania zgody na przetwarzanie danych osobowych w
            celach
            marketingowych, jednakże nie dłużej niż 5 lat od dnia jej wyrażenia.</p>

          <p>6. Z zastrzeżeniem warunków określonych w przepisach RODO przysługują Pani/Panu następujące prawa:</p>
          a. prawo do cofnięcia zgody w dowolnym momencie bez wpływu na zgodność z prawem przetwarzania, którego
          dokonano na podstawie zgody<br>
          przed jej cofnięciem poprzez wejście w link znajdujący się w wiadomości e-mail jaką otrzyma Pani/Pan po
          wyrażeniu zgód;<br>
          b. prawo do wniesienia sprzeciwu wobec przetwarzania Pani/Pana danych osobowych, w tym sprzeciwu wobec
          profilowania do celów
          marketingu bezpośredniego;<br>
          c. prawo do żądania od administratora dostępu do swoich danych osobowych, ich sprostowania, usunięcia lub
          ograniczenia ich przetwarzania,
          a także prawo do przenoszenia danych;<br>
          d. prawo wniesienia skargi do organu nadzorczego (Prezesa Urzędu Ochrony Danych Osobowych) w przypadku
          uznania, że przetwarzanie
          danych osobowych Panią/Pana dotyczących narusza przepisy RODO.<br>

          <p>7. Podanie przez Panią/Pana danych osobowych jest dobrowolne.</p>
        </div>
      </collapse>
    </content-wrapper>
    <content-wrapper type="small">
      <button-component
        :disabled="!isValid"
        fixed-width
        @click="submit"
      >
        Wyślij teraz
      </button-component>
    </content-wrapper>
  </step-wrapper>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import store from '@/store'
import isValidEmail from '@/assets/js/isValidEmail'
import StepWrapper from '@/components/StepWrapper'
import FormComponent from '@/components/Form'
import ContentWrapper from '@/components/ContentWrapper'
import StepHeader from '@/components/StepHeader'
import TextInput from '@/components/TextInput'
import ButtonComponent from '@/components/Button'
import CheckboxComponent from '@/components/Checkbox'
import Collapse from '@/components/Collapse'

export default {
  components: {
    StepWrapper,
    StepHeader,
    ContentWrapper,
    ButtonComponent,
    FormComponent,
    Collapse
  },
  data () {
    return {
      text: `
        Zostaw nam swoje&nbsp;dane<br>oraz zaakceptuj&nbsp;zgody
      `,
      formModel: {
        name: '',
        email: '',
        personalAgreement: false,
        commercialAgreement: false
      },
      form: [
        {
          key: 'name',
          component: TextInput,
          props: {
            placeholder: 'Imię i nazwisko *',
            required: true
          },
          halfSize: true
        },
        {
          key: 'email',
          component: TextInput,
          props: {
            placeholder: 'E-mail *',
            required: true,
            type: 'email'
          },
          halfSize: true
        },
        {
          key: 'personalAgreement',
          component: CheckboxComponent,
          props: {
            content: `
              Wyrażam zgodę na przetwarzanie moich danych osobowych w
              związku z przesłaniem propozycji miejsca na stronę
              To miasto przez Grupę Żywiec S.A. w celach marketingowych,
              w tym dla informowania o nowościach i wydarzeniach,
              badań satysfakcji ze świadczonych usług, statystyki handlowej,
              przedstawienia oferty. Przysługuje Pani/Panu prawo do
              cofnięcia zgody w dowolnym momencie bez wpływu na zgodność z prawem
              przetwarzania, którego dokonano na podstawie zgody.
            `,
            required: true
          }
        },
        {
          key: 'commercialAgreement',
          component: CheckboxComponent,
          props: {
            content: `
              Wyrażam zgodę na otrzymywanie drogą elektroniczną informacji
              handlowych w rozumieniu ustawy z dnia 18 lipca 2002 r. o świadczeniu
              usług drogą elektroniczną (tekst jedn. Dz. U. z 2017 poz. 1219 z późn. zm.).
              o treści marketingowej pochodzących od Grupy Żywiec S.A. oraz na
              wykorzystywanie przez Grupę Żywiec S.A. telekomunikacyjnych urządzeń
              końcowych i automatycznych systemów wywołujących dla celów marketingu
              bezpośredniego w rozumieniu przepisów ustawy z dnia  16 lipca 2004 r.
              - Prawo telekomunikacyjne (tekst jedn. Dz. U. z 2017 poz. 1907  z późn. zm.).
            `
          }
        }
      ],
      isValid: false
    }
  },
  computed: {
    ...mapState({
      success: state => state.add.success
    })
  },
  watch: {
    formModel () {
      this.validateModel()
    }
  },
  beforeRouteEnter (to, from, next) {
    const currentStep = store.getters.currentAddPlaceStep
    if (currentStep > 3) {
      next()
    } else {
      next({ name: `add-step-${ currentStep }` })
    }
  },
  methods: {
    ...mapActions(['applyPlace']),
    validateModel () {
      const { name, email, personalAgreement } = this.formModel
      this.isValid = name && isValidEmail(email) && personalAgreement
    },
    submit () {
      this.validateModel()

      if (this.isValid) {
        this.applyPlace(this.formModel)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .hamburger {
    z-index: z(logo) + 1000;
  }
</style>



// WEBPACK FOOTER //
// src/containers/AddPlace/AddFourthStep.vue